<template>
  <div id="help-center">
    <div class="help-center-container">
      <div class="help_details">
        <h1>{{ helpCenterText.title }}</h1>
        <span>
          {{ replaceText(helpCenterText.text1) }}
        </span>
        <div class="contact_container">
          <div class="contact_list">
            <img src="images/credit-card-ui/email.png" alt="email" />
            <p>{{ replaceText(helpCenterText.text2) }}</p>
          </div>

          <!-- Credit Card only if any of the five product flags is true -->
          <div
            v-if="
              isImmersiLearn ||
              isXRLab360 ||
              isTheNextGenXR ||
              isVirtuPaths ||
              isXRLAB
            "
            class="contact_list"
          >
            <img src="images/credit-card-ui/phone-call.png" alt="phone" />
            <p>{{ helpCenterText.text3 }}</p>
          </div>

          <!-- otherwise, fall back to the three regional numbers -->
          <template v-if="!isXRStudios">
            <div class="contact_list" v-if="!isXRLab360">
              <img src="images/credit-card-ui/phone-call.png" alt="phone" />
              <p>{{ helpCenterText.text4 }}</p>
            </div>
            <div class="contact_list" v-if="!isXRLab360">
              <img src="images/credit-card-ui/phone-call.png" alt="phone" />
              <p>{{ helpCenterText.text5 }}</p>
            </div>
            <div class="contact_list" v-if="!isXRLab360">
              <img src="images/credit-card-ui/phone-call.png" alt="phone" />
              <p>{{ helpCenterText.text6 }}</p>
            </div>
          </template>
        </div>

        <div class="Unsub_btn" v-if="msisdnPresent" @click="unsubscribe">
          <span>{{ helpCenterText.text7 }}</span>
        </div>
        <p style="color: red; font-size: 12px" v-if="showErrorMessage">
          {{ errorMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { waitForLoaderToHide } from "../../aframe/utils/scene.utils";
import { webstore } from "../helpers/auth-helpers";
import { HELP_CENTER_UTM_CAMPAIGN } from "../helpers/page-constants";
import { redirectUnsubscribeForCreditCard } from "../utils/redirect.utils";
import { isCreditCardProduct } from "../utils/isCreditCardProduct";
import { replaceText } from "../helpers/domain-text-config";
import { getHelpCenterText } from "../helpers/help-center-page.data";

import {
  isImmersiLearn,
  isXRLab360,
  isTheNextGenXR,
  isVirtuPaths,
  isXRLAB,
} from "../utils/isCreditCardProduct";
import { config } from "../helpers/domain-config";
import { Endpoints } from "../../endpoints";

export default {
  data: () => ({
    msisdnPresent: !!webstore.getProperty("msisdn"),
    errorMessage: "",
    showErrorMessage: false,
    isImmersiLearn,
    isXRLab360,
    isTheNextGenXR,
    isVirtuPaths,
    isXRLAB,
    isXRStudios: config.productName === "xrstudios",
    helpCenterText: null,
  }),
  async created() {
    waitForLoaderToHide();
    this.helpCenterText = await getHelpCenterText();
  },
  methods: {
    unsubscribe() {
      if (isCreditCardProduct) {
        redirectUnsubscribeForCreditCard(HELP_CENTER_UTM_CAMPAIGN);
      }
    },
    showError(msg) {
      this.showErrorMessage = true;
      this.errorMessage = msg;
    },
    hideError() {
      this.showErrorMessage = false;
      this.errorMessage = "";
    },
    replaceText,
  },
};
</script>

<style lang="scss">
.help-center-container {
  color: #fff;
  margin-top: 11%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  .help_details {
    margin: 0;
    padding: 2rem;
  }
  .Unsub_btn {
    cursor: pointer;
    background: linear-gradient(
      90deg,
      rgba(45, 239, 224, 1) 0%,
      rgba(45, 155, 239, 1) 57%,
      rgba(53, 237, 251, 1) 100%
    );
    width: 80%;
    max-width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 60px;
    padding: 18px 0px;
    //margin-top: 10%;
  }
  .contact_container {
    margin-top: 3%;

    .contact_list {
      display: flex;
      align-items: center;
      margin-left: 5%;
      margin-bottom: 2%;

      img {
        width: 25px;
      }

      p {
        margin: 0 0 0% 20px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .help_details {
      .contact_container {
        margin-top: 5%;

        .contact_list {
          margin-bottom: 6%;
        }
      }
    }
  }
}
</style>
